import React from 'react'

export const Choose1 = ({ img, heading, paragraph }) => {
  return (
    <div className='p-8 rounded-lg flex flex-col items-center gap-2 bg-[#161616]'>
      <div>
        <img src={img} alt="" />
      </div>
      <div className='flex flex-col items-center gap-2'>
        <p className='lg:text-[23px] text-[15px] font-bold text-white'>{heading}</p>
        <p className='lg:text-[17px] text-[12px] text-center text-white text-opacity-75'>{paragraph}</p>
      </div>

    </div>
  )
}
export const Choose11 = ({ img, heading, paragraph }) => {
  return (
    <div className='p-8 rounded-lg flex flex-col gap-2 bg-[#06000A]'>
      <div>
        <img src={img} alt="" />
      </div>
      <div className='flex flex-col gap-2'>
        <p className='lg:text-[23px] text-[15px] font-bold text-white'>{heading}</p>
        <p className='lg:text-[17px] text-[12px] text-white text-opacity-75'>{paragraph}</p>
      </div>

    </div>
  )
}

export const Choose2 = ({ img, heading, paragraph }) => {
  return (
    <div className='p-8 rounded-lg flex flex-col gap-2 bg-[#161616] border-[1px] border-blue-700 items-center'>
      <div>
        <img src={img} alt="" />
      </div>
      <div className='flex flex-col items-center gap-2'>
        <p className='lg:text-[23px] text-[15px] text-center font-bold bg-clip-text text-transparent bg-gradient-to-r from-blue-500 to-blue-700'>{heading}</p>
        <p className='lg:text-[17px] text-center text-[12px] text-white text-opacity-75'>{paragraph}</p>
      </div>
    </div>
  )
}
export const Choose22 = ({ img, heading, paragraph }) => {
  return (
    <div className='p-8  rounded-lg flex flex-col gap-2 bg-[#06000A] border-[1px] border-blue-700'>
      <div>
        <img src={img} alt="" />
      </div>
      <div className='flex flex-col gap-2'>
        <p className='lg:text-[23px] text-[15px] font-bold bg-clip-text text-transparent bg-gradient-to-r from-blue-500 to-blue-700'>{heading}</p>
        <p className='lg:text-[17px] text-[12px] text-white text-opacity-75'>{paragraph}</p>
      </div>
    </div>
  )
}
export const Milestone = ({ img, heading, paragraph }) => {
  return (
    <div className='flex flex-row'>
      <div>
        <img className='' src={img} alt="" />
      </div>
      <div>
        <p className='lg:text-[23px] text-[15px] font-bold bg-clip-text text-transparent bg-gradient-to-r from-blue-500 to-blue-700'>{heading}</p>
        <p className='lg:text-[17px] text-[12px] text-white text-opacity-75'>{paragraph}</p>
      </div>
    </div>
  )
}


//props for hosting page cards
export const Hostingcards = ({ img, heading, paragraph }) => {
  return (
    <div className='p-3 py-4 lg:w-[240px] h-[210px] w-full lg:my-0 my-[3%] rounded-lg gap-2 flex flex-col bg-[#161616] z-[600] border-[#767171] border-2'>
      <div>
        <img src={img} alt="" />
      </div>
      <div className='flex flex-col gap-2'>
        <p className='lg:text-[23px] text-[15px] font-bold text-white'>{heading}</p>
        <p className='lg:text-[14px] text-[12px] text-white text-opacity-75'>{paragraph}</p>
      </div>

    </div>
  )
}
